export * from '@primeuix/themes/material/badge';
export { default } from '@primeuix/themes/material/badge';
